var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "card pa-0 mt-0",
    attrs: {
      "hover": "",
      "color": _vm.cardColor,
      "to": {
        name: _vm.buttonTo
      }
    }
  }, [_c('v-card-title', {
    staticClass: "card-title font-weight-black text-h5",
    class: ((_vm.color) + "--text")
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": _vm.color
    }
  }, [_vm._v(" " + _vm._s(_vm.icon) + " ")]), _vm._v(" " + _vm._s(_vm.buttonText) + " ")], 1), _c('v-card-text', {
    staticClass: "card-text pa-0",
    class: ((_vm.primaryTextColor) + "--text")
  }, [_c('v-img', {
    staticClass: "image",
    attrs: {
      "eager": "",
      "src": _vm.image,
      "min-height": "300px",
      "height": "100%",
      "max-height": "400px",
      "position": _vm.imagePosition || 'center center',
      "width": "100%"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }